import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PARTNERS_2026 } from "@/lib/platform";

export default function PartnerWall() {
  const navigate = useNavigate();

  return (
    <section data-testid="partner-wall" className="relative bg-[#07152B] text-[#F5EBD9] py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="mb-12 lg:mb-16 text-center"
        >
          <div className="inline-flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Партньори на изданието във Варна · 2026
            <span className="h-px w-10 bg-[#F5892E]" />
          </div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-6xl leading-[0.98] tracking-tight">
            Брандовете, които са част от играта
          </h2>
        </motion.div>

        {/* Monochrome logo wall */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-[#1E3A63] rounded-2xl overflow-hidden border border-[#1E3A63]">
          {PARTNERS_2026.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              data-testid={`wall-partner-${i}`}
              className="group bg-[#07152B] aspect-[5/3] flex items-center justify-center p-6 hover:bg-[#F5EBD9] transition-colors duration-500"
            >
              <img
                src={p.src}
                alt={p.name}
                loading="lazy"
                className="max-h-14 max-w-[75%] w-auto object-contain grayscale invert opacity-70 group-hover:grayscale-0 group-hover:invert-0 group-hover:opacity-100 transition-all duration-500"
              />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-12 text-center"
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#8A9EB8] mb-5">
            Искате вашият бранд да е тук?
          </div>
          <button
            onClick={() => { navigate("/partners"); window.scrollTo({ top: 0 }); }}
            data-testid="wall-cta-partner"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-[#F5892E] text-[#F5892E] font-bold text-sm uppercase tracking-widest hover:bg-[#F5892E] hover:text-[#0B1F3D] transition-all"
          >
            Станете партньор
            <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
